/**
 * Picks the phone type to default a new phone row to.
 *
 * Phone type is required (the ContactPhoneNumbers.PhoneTypeId FK is non-nullable), so a new row
 * must arrive with a sensible type already selected rather than blank. Prefers a mobile/cell/smart
 * phone type when one exists, otherwise falls back to the first available type.
 *
 * @param {Array<{id: number, value: string}>} phoneTypes
 * @returns {number|null} the id to default to, or null when there are no phone types
 */
export function pickDefaultPhoneTypeId(phoneTypes) {
  if (!Array.isArray(phoneTypes) || phoneTypes.length === 0) {
    return null;
  }

  const mobileLike = phoneTypes.find((pt) => /mobile|cell|smart/i.test(pt.value ?? ''));
  return (mobileLike ?? phoneTypes[0]).id;
}
